import React from "react";
import { Tab as Tab$1 } from "@mui/material";
import { makeStyles } from "tss-react/mui";
const useClasses = makeStyles()((theme) => ({
  tab: {
    display: "flex",
    flex: "1 1 auto",
    minWidth: "auto",
    maxWidth: "fit-content",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    padding: theme.spacing(0, 2),
    "& .MuiTab-wrapper": {
      justifyContent: "stretch",
      height: "100%"
    }
  },
  selected: {
    color: theme.palette.primary.main
  }
}));
function Tab({ value, label, ...props }) {
  const { classes } = useClasses();
  return /* @__PURE__ */ React.createElement(Tab$1, { ...props, className: classes.tab, value, label });
}
export {
  Tab
};
//# sourceMappingURL=Tab.js.map
